import React from 'react';
import ReactDOM from 'react-dom';
import { multiply, addIndex, forEach, compose, prop, map, merge, __ } from 'ramda';
import autoBind from '../../modules/autoBind';
import Benzinger from './Benzinger';

const colors = {
  blue: 'rgb(0, 0, 255)',
  red: 'rgb(255, 0, 0)',
  black: 'rgb(0, 0, 0)',
  axis: 'rgb(192, 192, 192)',
  gray: 'rgb(217, 217, 217)',
  white: 'rgb(255, 255, 255)',
  border: 'rgb(117, 113, 113)'
};

export default class BenzingerChart extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { canvas: null };
  }
  componentDidMount() {
    const canvas = document.createElement('canvas');
    canvas.setAttribute('style', 'width: 100%; height: 100%;');
    canvas.setAttribute('width', canvas.offsetWidth);
    canvas.setAttribute('height', canvas.offsetWidth);
    canvas.setAttribute('id', this.props.id);
    ReactDOM.findDOMNode(this).appendChild(canvas);
    this.setState({ canvas });
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    ReactDOM.findDOMNode(this).removeChild(this.state.canvas);
  }
  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }
  render() {
    if (this.state.canvas) {
      this.renderCanvas(this.state.canvas);
    }

    return <div style={{ marginBottom: '10px' }}></div>;
  }
  getProps() {
    return merge(this.props, {
      L2: Math.min(150, this.props.L2 * 4),
      A2: Math.min(150, this.props.A2 * 4),
      V2: Math.min(150, this.props.V2 * 4),
      I2: Math.min(150, this.props.I2 * 4),
    });
  }
  renderCanvas(canvas) {
    canvas.setAttribute('width', canvas.offsetWidth);
    canvas.setAttribute('height', canvas.offsetWidth);
    this.width = multiply(canvas.offsetWidth);
    this.height = multiply(canvas.offsetWidth);

    const ctx = canvas.getContext('2d');
    const width = this.width, height = this.height;
    const center = { x: width(.5), y: height(.5) };

    ctx.clearRect(0, 0, width(1), height(1));

    //inner circles
    ctx.lineWidth = 0;
    
    ctx.beginPath();
    ctx.arc(center.x, center.y, width(.50), 0, 2 * Math.PI, false);
    ctx.fillStyle = colors.border;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(center.x, center.y, width(.448), 0, 2 * Math.PI, false);
    ctx.fillStyle = colors.white;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(center.x, center.y, width(.370), 0, 2 * Math.PI, false);
    ctx.fillStyle = colors.gray;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(center.x, center.y, width(.294), 0, 2 * Math.PI, false);
    ctx.fillStyle = colors.white;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(center.x, center.y, width(.149), 0, 2 * Math.PI, false);
    ctx.fillStyle = colors.gray;
    ctx.fill();

    // dashed lines
    ctx.lineWidth = 1;
    ctx.strokeStyle = colors.axis;
    ctx.dashedLine(width(.5), height(.1), width(.5), height(.9), 2);
    ctx.dashedLine(width(.1), height(.5), width(.9), height(.5), 2);

    // draw numbers
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = colors.black;
    ctx.font = '7pt Arial';
    for (let quadrant = 0; quadrant < 4; quadrant++) {
      for (let num = 2; num < 13; num+=2) {
        let position = this.getDiagonalPosition(num * 10, quadrant);
        ctx.fillText((num*10).toString(), position.x, position.y);
      }
    }

    ctx.fillStyle = colors.white;
    ctx.font = 'bold 11pt Arial';

    const letters = ['8', '7', '1', '2'];
    const offset = [[-15, -11], [15, -11], [15, 11], [-15, 11]]
    const p = this.getProps();
    const addOffset = [Math.max(p.V1, p.V2), Math.max(p.A1, p.A2), Math.max(p.L1, p.L2), Math.max(p.I1, p.I2)].map((x) => x > 115);
    addIndex(forEach)((letter, index) => {
      const pos = this.getDiagonalPosition(129.4, index);
      ctx.fillText(letter, pos.x + (addOffset[index] && offset[index][0]), pos.y + (addOffset[index] && offset[index][1]));
    }, letters);

    // draw text
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    ctx.fillStyle = colors.black;
    ctx.font = '7pt Arial';
    
    ctx.fillText('CONCEPTUAL', width(.5), height(.08));
    ctx.fillText('ESTRATEGIA', width(.5), height(.11));
    
    ctx.fillText('PRÁCTICO', width(.5), height(.89));
    ctx.fillText('EJECUCIÓN', width(.5), height(.92));
    
    const drawVertical = (text, xPos, yPos) => {
      addIndex(forEach)((letter, index) => {
        const letterHeight = 9;
        ctx.fillText(letter, xPos, yPos - text.length*letterHeight/2 + 4 + letterHeight*index);
      }, text);
    };
    
    drawVertical('RACIONAL', width(.08), height(.5));
    drawVertical('TÉCNICO', width(.11), height(.5));

    drawVertical('ARTÍSTICO', width(.89), height(.5));
    drawVertical('CREATIVO', width(.92), height(.5));

    ctx.font = '7pt Arial';
    ctx.save();
    let textPos = this.getDiagonalPosition(140, 2);
    ctx.translate(textPos.x, textPos.y);
    ctx.rotate(Math.PI / 4);
    ctx.fillText('POSTERIOR IZQUIERDO', 0, 0);
    ctx.restore();

    ctx.save();
    textPos = this.getDiagonalPosition(140, 0);
    ctx.translate(textPos.x, textPos.y);
    ctx.rotate(Math.PI / 4);
    ctx.fillText('FRONTAL DERECHO', 0, 0);
    ctx.restore();

    ctx.save();
    textPos = this.getDiagonalPosition(140, 3);
    ctx.translate(textPos.x, textPos.y);
    ctx.rotate(-Math.PI / 4);
    ctx.fillText('POSTERIOR DERECHO', 0, 0);
    ctx.restore();

    ctx.save();
    textPos = this.getDiagonalPosition(140, 1);
    ctx.translate(textPos.x, textPos.y);
    ctx.rotate(-Math.PI / 4);
    ctx.fillText('FRONTAL IZQUIERDO', 0, 0);
    ctx.restore();

    // plot points
    const mapPropToPos = compose(
      addIndex(map)(this.getDiagonalPosition),
      map(prop(__, this.getProps())));

    const line = (x1, y1, x2, y2) => {
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    };

    const dashLine = ctx.dashedLine.bind(ctx);
    const drawLines = (positions, color, dashed, offsetX, offsetY) => {
      ctx.fillStyle = color;
      ctx.strokeStyle = color;
      ctx.lineWidth = 3;

      // draw lines
      for (let i = 0; i < 4; i++) {
        const pos1 = positions[i];
        const pos2 = positions[(i+1)%4];
        (dashed ? line: dashLine)(pos1.x + offsetX, pos1.y + offsetY, pos2.x + offsetX, pos2.y + offsetY, 2);
      }
    };

    ctx.font = 'bold 7pt Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = colors.white;
    
    const drawCircles = (positions, properties, color, offsetX, offsetY) => {
      // draw circles
      let i = 0; 
      forEach((pos) => {
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(pos.x + offsetX, pos.y + offsetY, width(.025), 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.fillStyle = colors.white;
        ctx.fillText(this.getProps()[properties[i++]], pos.x + offsetX, pos.y + offsetY);
      }, positions);
    };

    const quadrants2 = { L2: 2, A2: 1, V2: 0, I2: 3 };
    const positions2 = mapPropToPos(Benzinger.props().filter((prop) => prop[1] == '2').sort((a, b) => quadrants2[a] - quadrants2[b]));
    drawLines(positions2, colors.blue, false, -2, 2);
    const props2 = Benzinger.props().filter((prop) => prop[1] == '2');
    drawCircles(positions2, [props2[2], props2[1], props2[0], props2[3]], colors.blue, -2, 2);

    const quadrants1 = { L1: 2, A1: 1, V1: 0, I1: 3 };
    const positions1 = mapPropToPos(Benzinger.props().filter((prop) => prop[1] == '1').sort((a, b) => quadrants1[a] - quadrants1[b]));
    drawLines(positions1, colors.red, true, 2, -2);
    const props1 = Benzinger.props().filter((prop) => prop[1] == '1');
    drawCircles(positions1, [props1[2], props1[1], props1[0], props1[3]], colors.red, 2, -2);
  }
  getDiagonalPosition(scale, quadrant) {
    const rightSide = quadrant === 0 || quadrant === 3;
    const upSide = quadrant === 0 || quadrant === 1;

    const zeroOffsetX = this.width(.45)/121.5*Math.sin(Math.PI/4)*scale * (rightSide ? 1 : -1);
    const zeroOffsetY = this.height(.45)/121.5*Math.sin(Math.PI/4)*scale * (upSide ? -1 : 1);

    return {
      x: this.width(.5) + zeroOffsetX,
      y: this.height(.5) + zeroOffsetY,
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/benzinger/Chart.jsx